import React from 'react';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-12 max-w-3xl">
        <h1 className="text-3xl font-serif text-provence-stone mb-6">Rechtliches</h1>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-provence-stone mb-3">Datenschutzerklärung</h2>
          <p className="text-provence-stone/80 mb-3">
            Wir nehmen den Schutz Ihrer Daten sehr ernst. Personenbezogene Daten werden ausschließlich zur
            Bearbeitung von Anfragen, Buchungen und zur Verbesserung unseres Angebots verarbeitet. Rechtsgrundlage
            hierfür sind insbesondere Art. 6 Abs. 1 lit. b und f DSGVO.
          </p>
          <ul className="list-disc pl-6 text-provence-stone/80 space-y-2">
            <li>Erhobene Daten: Kontaktangaben, Buchungsinformationen, Kommunikationsinhalte.</li>
            <li>Speicherdauer: Nur solange erforderlich bzw. gesetzlich vorgeschrieben.</li>
            <li>Weitergabe: Nur an Dienstleister, die zur Vertragserfüllung notwendig sind.</li>
            <li>Ihre Rechte: Auskunft, Berichtigung, Löschung, Einschränkung, Widerspruch, Datenübertragbarkeit.</li>
            <li>Kontakt für Datenschutzanfragen: privacy@mascapon.com</li>
          </ul>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-provence-stone mb-3">Allgemeine Geschäftsbedingungen (AGB)</h2>
          <p className="text-provence-stone/80 mb-3">
            Mit einer Buchung kommt ein Mietvertrag zwischen Ihnen und Mas Capon zustande. Die wesentlichen Punkte
            sind: Zahlungsfristen, Stornobedingungen, Hausordnung sowie Haftungsregelungen. Bitte beachten Sie die
            genaue Objektbeschreibung und die angegebenen Maximalbelegungen.
          </p>
          <ul className="list-decimal pl-6 text-provence-stone/80 space-y-2">
            <li>Buchung und Zahlung: Anzahlung bei Buchung, Restzahlung vor Anreise.</li>
            <li>Stornierung: Staffelung nach Zeitpunkt des Rücktritts; ggf. Anrechnung einer Gebühr.</li>
            <li>Nutzung: Sorgfältiger Umgang mit dem Objekt; Hausordnung ist verbindlich.</li>
            <li>Haftung: Haftung für grobe Fahrlässigkeit und Vorsatz; sonst nach gesetzlichen Vorschriften.</li>
            <li>Gerichtsstand: Nach gesetzlichen Bestimmungen; es gilt das anwendbare Recht am Objektstandort.</li>
          </ul>
        </section>

        <section className="mb-10">
          <h2 className="text-2xl font-semibold text-provence-stone mb-3">Impressum</h2>
          <div className="text-provence-stone/80 space-y-1">
            <p>Mas Capon</p>
            <p>Route du Mas Blanc</p>
            <p>13210 Saint-Rémy-de-Provence</p>
            <p>Frankreich</p>
            <p>E-Mail: contact@mascapon.com</p>
            <p>Telefon: +49 177 7700 444</p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Privacy;


